import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeGrossCommand extends BaseCommand {
  CommandName = "ChangeGross";
  Command: { TmpId: string; Value: number; Calculate: boolean };
  constructor(sessionId: string, operationId: string, tmpId: string, value: number, calculate: boolean) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, Value: value, Calculate: calculate };
  }
}
